import React, { useState } from 'react'
import { format } from 'date-fns'
import { Popover } from '@headlessui/react'
import { BsChevronDown } from 'react-icons/bs'
import classNames from 'classnames'
import { Controller, useForm } from 'react-hook-form'
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

const Calendar = ({
  fieldName = 'Select Date',
  getValues = () => {},
  setValue = () => {},
  clearErrors = () => {},
}) => {
  const [selectedDate, setSelectedDate] = useState()
  const { control } = useForm()

  const handleDate = (date) => {
    setValue(fieldName, format(new Date(date), 'MM-dd-yyyy'))
    setSelectedDate(date)
    clearErrors(fieldName)
  }

  const pascalToStringConvert =
    fieldName
      .replace(/([A-Z])/g, ' $1')
      .charAt(0)
      .toUpperCase() + fieldName.replace(/([A-Z])/g, ' $1').slice(1)

  return (
    <>
      <label className="text-xs text-custom-gray-80">
        {pascalToStringConvert}
        <span aria-hidden="true">*</span>
      </label>
      <Controller
        name={fieldName}
        control={control}
        render={() => (
          <Popover className="relative">
            {({ open }) => (
              <>
                <Popover.Button className="inline-flex justify-between px-2 py-2 items-center border-b border-b-custom-gray-80 w-full text-left focus:outline-none">
                  <span>
                    {getValues(fieldName)
                      ? getValues(fieldName)
                      : selectedDate
                      ? format(new Date(selectedDate), 'yyyy-MM-dd')
                      : '--'}
                  </span>
                  <BsChevronDown
                    className={
                      'text-custom-gray-80 mr-2 transition duration-150 ease-in-out group-hover:text-opacity-80'
                    }
                    aria-hidden="true"
                  />
                </Popover.Button>
                <Popover.Panel
                  className={`absolute z-10 bg-black border border-custom-gray-80 text-white w-full -translate-y-20`}
                >
                  {({ close }) => (
                    <>
                      <div className="p-4">
                        <label className="text-xs text-custom-gray-80">
                          {pascalToStringConvert}
                          <span aria-hidden="true">*</span>
                        </label>
                        <div className="flex justify-between items-center">
                          <span>
                            {getValues(fieldName)
                              ? getValues(fieldName)
                              : selectedDate
                              ? format(new Date(selectedDate), 'yyyy-MM-dd')
                              : '--'}
                          </span>
                          <BsChevronDown
                            className={open ? 'rotate-180 transform cursor-pointer' : ''}
                            onClick={() => close()}
                          />
                        </div>
                      </div>
                      <ReactDatePicker
                        onChange={(date) => {
                          close(), handleDate(date)
                        }}
                        minDate={new Date()}
                        maxDate={new Date('9999-12-31')}
                        open={true}
                        inline
                        selected={selectedDate}
                        className={classNames(
                          'w-full opacity-80 bg-black px-2 leading-10 text-white outline-none'
                        )}
                      />
                    </>
                  )}
                </Popover.Panel>
              </>
            )}
          </Popover>
        )}
      />
    </>
  )
}

export default Calendar
